// components/Gacha/ItemDraw.jsx
import { useState, useEffect } from 'react';
import {
  Box, Button, Typography, CircularProgress, Alert, Card, CardContent
} from '@mui/material';
import api from '../../api/axios';

const ItemDraw = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [tierColors, setTierColors] = useState({});
  const [price, setPrice] = useState(10); // 기본 가격 fallback
  const [userPoint, setUserPoint] = useState(0);

  // ✅ 색상 불러오기
  useEffect(() => {
    api.get('/api/rewards/tier-probability/')
      .then(res => {
        const map = {};
        (res.data.tiers || []).forEach(t => {
          map[t.tier] = t.color;
        });
        setTierColors(map);
      });
  }, []);

  // ✅ 뽑기 가격 불러오기
  useEffect(() => {
    api.get('/api/gacha/config/')
      .then(res => {
        const itemCfg = res.data.configs?.find(c => c.type === 'item');
        if (itemCfg) setPrice(itemCfg.price);
      });
  }, []);

  // ✅ 유저 포인트 불러오기
  useEffect(() => {
    api.get('/api/user-info/')
      .then(res => {
        setUserPoint(res.data.points || 0);
      });
  }, []);

  const getTierColor = (tier) => tierColors[tier] || '#cccccc';
  const isInsufficient = userPoint < price;

  const handleDraw = () => {
    setLoading(true);
    setError('');
    setResult(null);

    api.post('/api/gacha/draw/', { type: 'item' })
      .then(res => {
        setResult(res.data);
        setUserPoint(res.data.remaining_points); // 포인트 갱신
      })
      .catch(err => {
        setError(err.response?.data?.message || '뽑기 요청에 실패했습니다.');
      })
      .finally(() => setLoading(false));
  };

  return (
    <Box sx={{ maxWidth: 480, mx: 'auto', mt: 4 }}>
      <Typography variant="h5" gutterBottom>🎁 아이템 뽑기</Typography>

      <Typography variant="body2" sx={{ mb: 1 }}>
        가격: {price}Leaf / 보유: {userPoint}Leaf
      </Typography>

      <Button
        variant="contained"
        fullWidth
        onClick={handleDraw}
        disabled={loading || isInsufficient}
      >
        {loading
          ? <CircularProgress size={24} />
          : isInsufficient
            ? '포인트 부족'
            : '아이템 뽑기'}
      </Button>

      {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}

      {result && (
        <Card
          sx={{
            mt: 4,
            backgroundColor: getTierColor(result.item.tier),
            color: 'white',
            boxShadow: 3,
            borderRadius: 2
          }}
        >
          <CardContent>
            <Typography variant="subtitle1" gutterBottom>
              {result.is_duplicate ? '💡 이미 보유 중인 아이템' : '🎉 새로운 아이템 당첨!'}
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              {result.item.name}
            </Typography>
            <Typography variant="body2">
              등급: {result.item.tier}
            </Typography>
            <Typography variant="body2">
              남은 포인트: {result.remaining_points}
            </Typography>
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

export default ItemDraw;
